module.exports = __webpack_public_path__ + "img/imiwin-support.74a906c0.jpg";